import log from "eslint-plugin-react/lib/util/log";
import React, { useState, createContext, useEffect } from "react";
import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../hooks/useAuth";
import { getAllcarts, resetCart } from "../redux/slices/Cart";

export const CartContext = createContext();

export const CartListProvider = (props) => {
  let dispatch = useDispatch()
  const {user} = useAuth()
  const {carts, CartCount, subtotal, isCartEmpty, qtyLoading} = useSelector((state) => state.cart)
  // Clear cart after apply for loan
  const {
    isSaved,
  } = useSelector((state) => state.loan);
  const [cartList, setCartList] = useState([]);
  useEffect(() => {
        dispatch(getAllcarts())
        setCartList(carts);
  },
  [CartCount,subtotal])

  useEffect(() => {
        dispatch(resetCart())
        setCartList([]);
  },
  [isSaved])

  return (
    <CartContext.Provider value={[cartList, setCartList]}>
      {props.children}
    </CartContext.Provider>
  );
};
